import { WasmLoad } from "@pdfking/pdfium-wrapper/wasm"
import { CreateSingleton } from "@pdfking/tfunc"

import { init } from "../embedpdf-dist/index.js"
import wasm from "../embedpdf-dist/pdfium.wasm"

export const InitializePdfium = CreateSingleton(async () => {
  const wasmBinary = await WasmLoad(wasm)
  const pdfium = await init({ wasmBinary })
  pdfium.PDFiumExt_Init() // Initialize the PDFium extension library
  return pdfium
})
